import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'app/services/toast.service';

@Component({
    selector: 'app-date-range-filter',
    templateUrl: './date-range-filter.component.html',
    styleUrls: ['./date-range-filter.component.scss']
})
export class DateRangeFilterComponent implements OnInit {
    @Input() form: UntypedFormGroup;
    @Input() fromKeyLabel: string;
    @Input() toKeyLabel: string;
    @Input() fromControlName: string;
    @Input() toControlName: string;
    @Input() readonly: boolean = false;
    @Input() controlMaxWidth: string;
    @Input() outlineLabels: boolean = false;

    minDate: Date;
    maxDate: Date;

    constructor(
        private toastService: ToastService,
        private translateService: TranslateService,
    ) { }

    ngOnInit(): void {
    }

    ngAfterViewInit(){
        this.form.valueChanges.subscribe(
            changes => {
                this.minDate = this.form.get(`${this.fromControlName}`)?.value;
                
                this.maxDate = this.form.get(`${this.toControlName}`)?.value;

                if(this.form.get(`${this.toControlName}`).value){
                    if(this.form.get(`${this.toControlName}`).invalid){
                        let msg = this.translateService.instant("DATE_RANGE.CANNOT_SET_DATETO_LESS_THAN_DATEFROM");
                        this.toastService.error(msg);
                    }
                }
            }
        )
    }

    handleKeyDown(e: KeyboardEvent){
        if(e.code !== "Backspace"){
          e.preventDefault();
          return;
        }
    }
}
